module.exports = __webpack_public_path__ + "static/media/k12_logo_old_2x.58bf8c7c.png";